import { getFullAddressWithArea } from 'helpers/location';
import { ENTITIES } from 'views/DocumentManagement/components/SaveToModal/constants';

export const getFields = (entity, data, isShort) => {
  if (entity === ENTITIES.SUPPLIER) {
    if (isShort) {
      return [
        {
          title: 'Supplier ID',
          value: data?.supplierId,
        },
        {
          title: 'Address',
          value: getFullAddressWithArea(data?.address, data?.area, true),
        },
      ];
    }
    return [
      {
        title: 'Supplier ID',
        value: data?.supplierId,
      },
      {
        title: 'Address',
        value: getFullAddressWithArea(data?.address, data?.area, true),
      },
      {
        title: 'Contact Person',
        value: data?.contactPerson,
      },
      {
        title: 'Email',
        value: data?.email,
      },
    ];
  } else {
    if (isShort) {
      return [
        {
          title: 'Factory ID',
          value: data?.factoryId,
        },
        {
          title: 'Address',
          value: getFullAddressWithArea(data?.address, data?.area, true),
        },
      ];
    }
    return [
      {
        title: 'Factory ID',
        value: data?.factoryId,
      },
      {
        title: 'Address',
        value: getFullAddressWithArea(data?.address, data?.area, true),
      },
      {
        title: 'Contact Person',
        value: data?.contactPerson,
      },
      {
        title: 'Email',
        value: data?.email,
      },
    ];
  }
};
